import "../styles/Home.css"
import Envelope from './Envelope';
import Gallery from './Gallery';
import Registry from './Registry';
import OpeningImage from './OpeningImage';


function Home() {
  return (

    <div>
    <OpeningImage/>
    <div className="home-container">
       <div className="hero"></div>
        <Envelope/>
        <Gallery/>
        <Registry/>
    
    
    </div>
    </div>
  );
}

export default Home;
